import gql from 'graphql-tag';
import { ApolloError, useQuery } from '@apollo/client';
import { ConsentType } from '__generated__/globalTypes';
import {
  PrivacyConsentRequirements,
  PrivacyConsentRequirementsVariables,
} from './__generated__/PrivacyConsentRequirements';

export const PRIVACY_CONSENT_REQUIREMENTS_QUERY = gql`
  query PrivacyConsentRequirements($subDomain: String!) {
    showPrivacyConsentStepOnSignup(subDomain: $subDomain) {
      showEEAExplicitDataStorageConsent
      consentRequirements
    }
  }
`;

const NO_CONSENTS_REQUIRED: ConsentType[] = [];

interface PrivacyConsentRequirementsOutput {
  showEEAExplicitDataStorageConsent?: boolean;
  consentRequirements: ConsentType[];
  loading: boolean;
  error?: ApolloError;
}

export const usePrivacyConsentRequirements = (
  subDomain: string,
): PrivacyConsentRequirementsOutput => {
  const { data, loading, error } = useQuery<
    PrivacyConsentRequirements,
    PrivacyConsentRequirementsVariables
  >(PRIVACY_CONSENT_REQUIREMENTS_QUERY, { variables: { subDomain } });

  const requirements = data?.showPrivacyConsentStepOnSignup;

  return {
    showEEAExplicitDataStorageConsent: loading
      ? undefined
      : (requirements?.showEEAExplicitDataStorageConsent ?? true),
    consentRequirements:
      requirements?.consentRequirements ?? NO_CONSENTS_REQUIRED,
    loading,
    error,
  };
};
